import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { DashboardStore } from "../../dashboard.store";
import { AccountantService } from "./accountant.service";
import { User } from "../../shared-data.service";

@Injectable({ providedIn: "root" })
export class CurrentWorkspaceService {
  dashboardStore = inject(DashboardStore);
  http = inject(HttpClient);
  accountantService = inject(AccountantService);
  availableStaff: User[] = [];

  constructor() {
    this.dashboardStore.currentCompanyChanged$.subscribe((company: any) => {
      if (company != null) {
        this.accountantService
          .getStaffMembers(company.id)
          .subscribe((res: User[]) => {
            console.log("available staff", res);
            this.availableStaff = res;
          });
      }
    });
  }
}
